import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthProvider } from 'src/app/providers';
import { CrmAlertComponent } from '../../fields';
import { LogService } from 'src/app/services';

@Component({
  selector: 'app-external-ask',
  templateUrl: './external-ask.page.html',
  styleUrls: ['./external-ask.page.scss']
})
export class ExternalAskPage implements OnInit {
  @ViewChild('alert') alert: CrmAlertComponent;
  email: any;
  reportId: any;
  externalAskForm: FormGroup;
  loading = false;
  authForm: FormGroup;
  codeVerifyFlag: boolean = false;
  constructor(private route: ActivatedRoute, private fb: FormBuilder,private authProvider: AuthProvider,private logService:LogService) {
    this.externalAskForm = this.fb.group({
      USER_EMAIL: [null, Validators.compose([Validators.required, Validators.pattern('[^ @]*@[^ @]*')])]
     
    });
    this.authForm = this.fb.group({
      AUTH_CODE: [null, Validators.compose([Validators.required, Validators.maxLength(6)])]
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      let token = params['token'];
      let decodeToken = atob(token);
      if (decodeToken.includes("email="))
        this.email = decodeToken.split("email=")[1];
        this.reportId = decodeToken.split("/")[2];
        this.externalAskForm.patchValue({
          USER_EMAIL: this.email
        })
    })
  }

  onSubmit(): void {
    if (this.externalAskForm.valid) {
      this.loading = true;
      const loginDetails = this.externalAskForm.value;
      this.authProvider.generateCode(loginDetails.USER_EMAIL, this.reportId)
        .subscribe(response => {
          if (response.success) {
            this.codeVerifyFlag = true;
          } else {
            this.alert.show(response.error);
          }
           this.loading = false;
        }, err => {
          this.logService.error(err);
           this.loading = false;
        });
    }
  }

  onAuthSubmit(): void {
    this.alert.hide();
    if (this.authForm.valid) {
      this.loading = true;
      const loginDetails = this.externalAskForm.value;
      this.authProvider.externalAuthVerify(loginDetails.USER_EMAIL, this.reportId, this.authForm.value.AUTH_CODE)
        .subscribe(response => {
          if (response.success) {
            this.authForm.reset();
            this.externalAskForm.reset();
            localStorage.setItem('R-CRM-TOKEN', response.result.token);

          } else {
            this.alert.show(response.error);
          }
          this.loading = false;
        }, (error: any) => {
          this.logService.error(error);
          this.loading = false;
          this.alert.showError(error.message);
        });
    }
  }
}
